import { ReferenceEntityName } from "../../../api/types/field-type";
import { ReferenceFieldConfig } from "./types";

export const REFERENCE_ENTITY_CONFIG: Record<
  ReferenceEntityName,
  ReferenceFieldConfig
> = {
  [ReferenceEntityName.Institution]: {
    entityType: ReferenceEntityName.Institution,
    searchStrategy: "realtime",
    component: "autocomplete",
    placeholder: "Search institutions...",
    searchMinLength: 2,
    searchDelay: 500,
    useHook: "useInstitutionsSearch",
  },
  [ReferenceEntityName.Tag]: {
    entityType: ReferenceEntityName.Tag,
    searchStrategy: "frontend",
    component: "dropdown",
    placeholder: "Select tags...",
    useHook: "useTagList",
  },
  [ReferenceEntityName.JourneyType]: {
    entityType: ReferenceEntityName.JourneyType,
    searchStrategy: "frontend",
    component: "dropdown",
    placeholder: "Select context...",
    useHook: "useJourneyTypes",
  },
  [ReferenceEntityName.CampusActivity]: {
    entityType: ReferenceEntityName.CampusActivity,
    searchStrategy: "frontend",
    component: "autocomplete",
    placeholder: "Search campus activities...",
    useHook: "useCampusActivities",
  },
  [ReferenceEntityName.Field]: {
    entityType: ReferenceEntityName.Field,
    searchStrategy: "realtime",
    component: "autocomplete",
    placeholder: "Search fields...",
    searchMinLength: 2,
    searchDelay: 500,
    useHook: "useFieldsSearch",
  },
  [ReferenceEntityName.Country]: {
    entityType: ReferenceEntityName.Country,
    searchStrategy: "frontend",
    component: "dropdown",
    placeholder: "Select country...",
    useHook: "useCountries",
  },
};

export const getReferenceConfig = (
  entityType: ReferenceEntityName,
): ReferenceFieldConfig => {
  const config = REFERENCE_ENTITY_CONFIG[entityType];

  // Fallback configuration for unknown reference entities
  if (!config) {
    console.warn(
      `No configuration found for reference entity: ${entityType}. Using default config.`,
    );
    return {
      entityType,
      searchStrategy: "realtime",
      component: "autocomplete",
      placeholder: `Search ${entityType}...`,
      searchMinLength: 2,
      searchDelay: 500,
      useHook: "",
    };
  }

  return config;
};
